import { Compass } from "@phosphor-icons/react";

import { AddExploreSectionForm } from "@/components/Explore/Forms/AddExploreSectionForm";
import type { ModalProps } from "@/shared.types";
import { Circle, Heading, Modal } from "@/ui";

// Modal for creating a new Explore section (e.g., "News & Blog")
// Shows form to enter section name and upload optional image
export const AddExploreSectionModal = ({ show, onClose }: ModalProps) => {
  return (
    <Modal
      show={show}
      title={
        <div className="flex flex-col gap-y-2">
          <Heading
            containerClassName="items-center"
            heading="Add New Section"
            left={
              <Circle>
                <Compass size={24} className="text-tertiary-800" />
              </Circle>
            }
          />
          <span className="text-base text-neutral-700">*Required fields</span>
        </div>
      }
      onClose={onClose}
    >
      <AddExploreSectionForm onClose={onClose} />
    </Modal>
  );
};
